// NOTE: ag-grid-enterprise registration/licensing moved to
// src/utility/agGridSetup.js (imported by the grid components themselves) so
// the ~1MB enterprise bundle stays out of the initial chunk.
import React, { Component } from "react";
import { createRoot } from "react-dom/client";
import "./stylesheet/index.scss";
import "./assets/canvas-icons/style.css";
import "bootstrap";
import "./assets/canvas-icon-new/style.css";
import App from "./containers/App";
import { BrowserRouter } from "react-router-dom";
import { validateAccessToken } from "./apiFactory/QueryBuilder";
import Login from "./components/Login/Login";
import { setUserProperties } from "./services/DashboardDesigner/amplitudeService";
import packageJson from "../package.json";
global.appVersion = packageJson.version;
import WithLoader from "./components/HOC/WithLoader";
import "regenerator-runtime/runtime.js";
import Maintenance from "./components/Miscellaneous/Maintenance/Maintenance";
import apiUrlConfig from "./environmentSettings";
// NOTE: FusionCharts initialization moved into the lazy-loaded Organization
// route (src/containers/Organization/Organization.js) — charts only render
// there, and keeping the import here pinned all FusionCharts modules + themes
// into the initial bundle.
import './services/axiosSetup';  // Import axios setup with interceptors
import './stylesheet/darkModeVariables.css';  // Dark / Light mode CSS custom properties
import GlobalErrorBoundary from './components/ErrorBoundary/GlobalErrorBoundary';
import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { ColorModeBridge } from './Contexts/ColorMode/ColorModeContext';
import { getColorModeStorageKey } from './utility/colorModeStorageKey';
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/styles';
const theme = createTheme();

class Index extends Component {
	constructor(props) {
		super(props);
		this.state = {
			authenticated: false,
			loading: true,userId:null
		};
	}
	

	componentDidMount() {
		let access_token = window.localStorage.getItem("$LoopBack$accessTokenId");
		let user_id = window.localStorage.getItem("$LoopBack$currentUserId");
		this.setState({"userId":user_id})
		// Check if user is already logged in.
		if (access_token && user_id) {
			validateAccessToken(access_token).then(data => {
				if (data.alive) {
					setUserProperties();
					this.setState({ loading: false, authenticated: true });
				} else {
					this.setState({ loading: false, authenticated: false });
				}
			});
		} else {
			this.setState({ loading: false, authenticated: false });
		}
	}

	// Adding this function to refresh the state after setting access token in local storage.
	userLoginSuccessful = () => {
		this.setState({ authenticated: true, loading: false });
	};
	

	render() {
		const AppEntryPoint = this.state.authenticated ? (
			<BrowserRouter>
				<GlobalErrorBoundary>
					<App />
				</GlobalErrorBoundary>
			</BrowserRouter>
		) : (
			<GlobalErrorBoundary>
				<Login userLoginSuccessful={this.userLoginSuccessful} />
			</GlobalErrorBoundary>
		);

		if(apiUrlConfig?.apiConfig?.maintenanceConfig?.onMaintenance && this.state.userId !== "1" ) {
			return (
				<GlobalErrorBoundary>
					<Maintenance
						start={apiUrlConfig.apiConfig.maintenanceConfig?.start}
						end={apiUrlConfig.apiConfig.maintenanceConfig?.end}
					/>
				</GlobalErrorBoundary>
			);
		}

		return (
			<NextThemesProvider
				attribute="data-color-mode"
				storageKey={getColorModeStorageKey()}
				defaultTheme="light"
				themes={['light', 'dark']}
				enableSystem={false}
				disableTransitionOnChange={false}
			>
				<ColorModeBridge>
					<ThemeProvider theme={theme}>
						<GlobalErrorBoundary>
							<WithLoader loading={this.state.loading}>
								{AppEntryPoint}
							</WithLoader>
						</GlobalErrorBoundary>
					</ThemeProvider>
				</ColorModeBridge>
			</NextThemesProvider>
		);
	}
}

const domNode = document.getElementById('root');
if (!domNode) {
	throw new Error("Root element with id 'app' not found. Please ensure your HTML template contains <div id=\"app\"></div>");
}
const root = createRoot(domNode);
root.render(<Index />);
